import { Controller } from "@hotwired/stimulus"

// «Sposta su» / «Sposta giù» dell'ordine di prevalenza degli atti (sposta(i, d) di pages/VerificaBandi.js): l'ordine
// diventa quello mostrato con le due voci scambiate e va nel campo `ordine` (JSON); il "change" del campo fa ridisegnare
// la lista a classi_documenti_controller e rende l'ordine un'unità modificata (conserva_modifiche_controller).
export default class extends Controller {
  static targets = ["stato"]

  su(event) { this.sposta(event, -1) }

  giu(event) { this.sposta(event, 1) }

  sposta(event, d) {
    const voce = event.currentTarget.closest("li")
    const ordine = [...this.element.querySelectorAll("li[data-doc-id]:not([hidden])")].map((li) => li.dataset.docId)
    const i = ordine.indexOf(voce?.dataset.docId)
    if (i < 0 || i + d < 0 || i + d >= ordine.length) return
    ;[ordine[i], ordine[i + d]] = [ordine[i + d], ordine[i]]
    this.statoTarget.value = JSON.stringify(ordine)
    this.statoTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }
}
